import { render } from "./App.vue?vue&type=template&id=115e271b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=115e271b&lang=css"

import exportComponent from "/Users/alexis/Desktop/Software/grupo_albarran_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__